import dynamic from 'next/dynamic'
import { RequestLeasingWizardProps } from './RequestLeasingOptionWizard'

export const DynamicRequestLeasingOptionWizard =
  dynamic<RequestLeasingWizardProps>(() =>
    import('./RequestLeasingOptionWizard').then(
      (md) => md.RequestLeasingOptionWizard
    )
  )
